import React from "react";
import InuaLoader from "./InuaLoader";

// --- LOADER (app-wide "please wait" indicator) ---
// Previously the Uiverse-by-alexruix reshuffling boxes, fixed to
// #1006C5. Now a thin wrapper around InuaLoader using the "app" variant
// (gradient #1006C5 -> #ffb800) — this is the generic, not-tied-to-any-
// specific-category loader used everywhere something is loading (e.g.
// Orders' "Loading your bookings", Account's "Loading your wishlist").
//
// The public API is unchanged on purpose: every existing
// `<Loader message="..." scale={0.4} />` call site keeps working exactly
// as before with zero edits elsewhere in the app.
//
// Two ways to use it:
//   <Loader />                          — bare mark, drop inline anywhere
//   <Loader fullScreen message="One moment" />  — full-page/-panel takeover
export interface LoaderProps {
  /** Renders as a full-height centered takeover instead of an inline mark. */
  fullScreen?: boolean;
  /** Optional line of text under the mark (e.g. "One moment"). */
  message?: string;
  /** Scales the whole mark down for tight spaces (e.g. inline in a table row). */
  scale?: number;
}

export default function Loader({
  fullScreen = false,
  message,
  scale = 1,
}: LoaderProps) {
  return (
    <InuaLoader
      variant="app"
      fullScreen={fullScreen}
      message={message}
      scale={scale}
    />
  );
}
